import { ArticleParagraph2 } from '@cian/ui-kit';

export const PskTooltipContent = () => {
  return (
    <ArticleParagraph2>
      Этот показатель включает в себя не только проценты по кредиту, но и другие возможные платежи. Например:
      <ul>
        <li>комиссию за оценку объекта;</li>
        <li>страховку;</li>
        <li>плату за обслуживание.</li>
      </ul>
      Сейчас полная стоимость кредита показана в процентах годовых, как диапазон. Его верхняя граница — это максимум,
      который вы можете переплатить сверх суммы кредита. Точную полную стоимость кредита банк рассчитает перед сделкой —
      она будет указана в документах.
    </ArticleParagraph2>
  );
};
